import TomSelect from 'tom-select';

export default class SellersMap {
  constructor() {
    this.map = document.querySelector('[data-sellers-map]');
    this.agents = document.querySelectorAll('[data-sellers-from-area-id]');
    this.search_agents_form = document.querySelector('[data-search-agents]');
    this.currentAreaId = null;
    this.tom_select = null;
  }

  init() {
    if (!this.map || !this.agents) {
      return false;
    }

    this.tomSelect();
    this.handleAreaHover();
    this.handleClick();
  }

  tomSelect() {
    this.tom_select = new TomSelect("#obszar", {
      create: false,
      render: {
        no_results: function (data, escape) {
          return '<div class="no-results">Nie znaleziono "' + escape(data.input) + '"</div>';
        },
      },
    });

    this.tom_select.on('change', (e) => {
      let data = e.split('_');
      let id = data[1];
      let slug = data[0];

      this.activateAreaAndAgents(id);
      // this.updateSelect(slug, id);
    })

  }


  handleAreaHover() {
    const areas = this.map.querySelectorAll('[data-voivodeship-area]');
    areas.forEach( (area) => {
      area.addEventListener('mouseenter', () => {
        let id = area.dataset.voivodeshipArea;
        this.activeArea(id, '0.8');
      });
    })

    areas.forEach( (area) => {
      area.addEventListener('mouseleave', () => {
        let id = area.dataset.voivodeshipArea;
        this.deactivateArea(id);
      });
    })
  }

  activeArea(id, opacity) {
    if(id === this.currentAreaId) {
      return;
    }
    const areas_with_the_same_id = this.map.querySelectorAll('[data-voivodeship-area="'+id+'"]');
      areas_with_the_same_id.forEach( (area_withe_the_same_id) => {
        area_withe_the_same_id.style.fill = '#485159';

        if(opacity) {
          area_withe_the_same_id.style.opacity = '0.8';
        }

      })
  }

  deactivateArea(id) {
    if(id === this.currentAreaId) {
      return;
    }

    const areas_with_the_same_id = this.map.querySelectorAll('[data-voivodeship-area="'+id+'"]');
      areas_with_the_same_id.forEach((area_withe_the_same_id) => {
        area_withe_the_same_id.style.fill = '';
      })
  }

  deactivateAllAreas() {
    const areas = this.map.querySelectorAll('[data-voivodeship-area]');
    areas.forEach( (area) => {
      area.style.fill = '';
    })
  }

  handleClick() {
    const areas = this.map.querySelectorAll('[data-voivodeship-area]');
    areas.forEach( (area) => {
      area.addEventListener('click', () => {
        let voivodeship_slug = area.dataset.voivodeshipSlug;
        let id = area.dataset.voivodeshipArea;
        console.log('click');
        console.log(id);
        console.log(voivodeship_slug);
        this.activateAreaAndAgents(id);
        // this.updateSelect(voivodeship_slug, this.currentAreaId);
      }, false);
    })
  }

  activateAreaAndAgents(id) {
    this.deactivateAllAreas();
    this.activeArea(id, '1');
    this.activeAgents(id);
    this.currentAreaId = id;
  }

  updateSelect(slug, area_id) {
    this.tom_select.addItem(slug + '_' + area_id, false);
  }

  activeAgents(id) {

    this.agents.forEach((item) => {
      let item_id = item.dataset.sellersFromAreaId;
      if(item_id === id) {
        this.showElement(item);
      } else {
        this.hideElement(item);
      }
    });
  }

  showElement(dom_item) {
    dom_item.classList.add('is-open');
  }
  hideElement(dom_item) {
    dom_item.classList.remove('is-open');
  }

}
